import { Button, Icon, Row, Upload, message, Table, Tabs, Spin, Tooltip } from 'antd'
import moment from 'moment'
import axios from 'axios'
import React, { Component } from 'react'
import './bulk-upload.scss'
import { BULK_UPLOAD_COLUMNS } from './constants'
import fetchData from 'utils/fetchData'
import downloadIcon from "./assets/download.svg";
import excelIcon from "./assets/excel.svg";
import sampleFile from "./assets/configurations.xlsx";
import createSampleFile from "./assets/create_notification_configuration_template.xlsx";
import updateSampleFile from "./assets/update_notification_configuration_template.xlsx";
import replaceSampleFile from "./assets/replace_notification_configuration_template.xlsx";
import deleteSampleFile from "./assets/delete_notification_configuration_template.xlsx";
import { UploadState } from './UploadState'
import { LEGO } from '../../constants'
const { TabPane } = Tabs;
const {
  BULK_UPLOAD,
  REACT_APP_ENTITY_SERVICE_URL,
  REACT_APP_EQS_SERVICE_API_URL,
  REACT_APP_BULK_ENGINE_SERVICE_URL } = window._env_;
const { headingMap } = BULK_UPLOAD;

const { Dragger } = Upload
const formatComponentName = (value = '') =>
  value
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
    .trim();

const BULK_UPLOAD_KEYS = {
  create: 'create_old_lego_notification',
  update: 'update_old_lego_notification',
  replace: 'replace_old_lego_notification',
  delete: 'delete_old_lego_notification',
};

class BulkUpload extends Component {
  state = {
    file: null,
    uploadedData: [],
    activeTab: 'create',
    uploadState: new UploadState(),
    isUploading: false,
    isLoading: false,
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props

    if (params.component) {
      this.getUploadedData(1)
    }
  }

  handleTabChange = (activeTab) => {
    this.setState((prevState) => {
      const uploadState = prevState.uploadState || new UploadState();
      const uploadFile = uploadState.getFile(activeTab);
      return {
        activeTab,
        file: uploadFile ? uploadFile.originFileObj : null,
      };
    }, () => {
      this.getUploadedData(1, activeTab);
    });
  }

  handleFileUpload = (file) => {
    this.setState((prevState) => {
      const uploadState = prevState.uploadState ? prevState.uploadState.clone() : new UploadState();
      const tab = prevState.activeTab || 'create';
      const uploadFile = {
        uid: `${Date.now()}-${file.name}`,
        name: file.name,
        status: 'done',
        originFileObj: file,
      };
      uploadState.setFile(tab, uploadFile);
      return {
        uploadState,
        file,
      };
    });
    return false;
  }

  handleRemoveFile = () => {
    this.setState((prevState) => {
      const uploadState = prevState.uploadState ? prevState.uploadState.clone() : new UploadState();
      const tab = prevState.activeTab || 'create';
      uploadState.clearFile(tab);
      return {
        uploadState,
        file: null,
      };
    });
    return true;
  }

  getUploadedData = (page = 1, activeTab = this.state.activeTab) => {
    const configKey = BULK_UPLOAD_KEYS[activeTab] || BULK_UPLOAD_KEYS.create;
    let url = `${REACT_APP_ENTITY_SERVICE_URL}/v1/template/BulkSearch?page=${page}&config_key=${configKey}`
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('satellizer_token')}`,
      source: LEGO
    }

    this.setState({ isLoading: true });
    fetchData(url, 'GET', {}, headers)
      .then(async (res) => {
        if (res && res.success && res.data && res.data.data) {
          const transformData = await this.transformData(res.data.data);
          this.setState({
            uploadedData: transformData,
            pagination: {
              current: page || 1,
              total: res.data.totalElements,
              pageSize: 10,
            }
          })
        }
      })
      .catch(error => {
        console.error('Failed to fetch uploaded files data', error);
        message.info(`Failed to fetch uploaded files data: ${error.message || error}`);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  transformData = async (bulkUploadData) => {
    if (bulkUploadData && Array.isArray(bulkUploadData)) {
      const transformedData = bulkUploadData.map(item => {
        let uploadType = '';
        if (item.config_key) {
          // Get the first part before the first underscore and capitalize
          uploadType = item.config_key.split('_')[0];
          uploadType = uploadType.charAt(0).toUpperCase() + uploadType.slice(1);
        }
        let enable_download = false;
        if (item.status === 'IN_PROGRESS') item.status = 'Processing';
        else if (item.status === 'COMPLETED') {
          enable_download = true
          if (item.total_count === item.success_count) {
            item.status = 'Upload completed';
          } else if (item.total_count === item.failure_count) {
            item.status = 'Failed upload';
          } else {
            item.status = 'Partially uploaded';
          }
        }
        return {
          key: item.fteid,
          name: item.filename,
          upload_type: uploadType,
          uploaded_by: item.created_by,
          status: item.status,
          enable_download: enable_download,
          total: item.total_count,
          success: item.success_count,
          failure: item.failure_count,
          created_at: moment(item.created_at).format('DD/MM/YYYY HH:mm:ss'),
        };
      });
      // return transformedData
      const TransformedDataWithUserIds = await this.mapUserIdsToPaginatedList(transformedData, this.props.dispatch);
      return TransformedDataWithUserIds;

    } else {
      return [];
    }
  }

  mapUserIdsToPaginatedList = async (paginatedList) => {
    if (!Array.isArray(paginatedList) || paginatedList.length === 0) {
      return [];
    }

    const entityFteids = paginatedList.map(item => item.uploaded_by);
    try {
      const entities = await this.getEntitiesByEntityId(entityFteids);
      const list = paginatedList.map(item => {
        const user = entities.find(user => user.fteid === item.uploaded_by);
        return {
          ...item,
          uploaded_by: (user && user.email_address),
        };
      })
      return list;
    } catch (error) {
      message.error(`Failed to map user details: ${error.message || error}`);
      return [];
    }
  }

  getEntitiesByEntityId = async (entityFteids) => {
    if (!entityFteids || entityFteids.length === 0) return [];
    const uniqueUserFteids = [...new Set(entityFteids)];
    const payload = uniqueUserFteids.join(',');
    const url = `${REACT_APP_EQS_SERVICE_API_URL}/v1/entity/company-data/${payload}`;
    try {
      const token = localStorage.getItem("satellizer_token");
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          source: "lego"
        },
      });
      if (response.data && response.data.success && response.data.data) return response.data.data
      else return [];
    } catch (error) {
      message.error(`Failed to fetch user details: ${error.message || error}`);
      return [];
    }
  };

  saveBulkUpload = () => {
    const { uploadState, activeTab } = this.state;
    const currentUploadFile = uploadState.getFile(activeTab);
    const fileToUpload = currentUploadFile && currentUploadFile.originFileObj;
    const originalFileName = currentUploadFile && currentUploadFile.name;

    if (!fileToUpload) {
      message.error("Oops!! Please select a file before uploading.");
      return;
    }

    const key = BULK_UPLOAD_KEYS[activeTab] || BULK_UPLOAD_KEYS.create;
    const formData = new FormData();
    const safeFileName = (originalFileName || fileToUpload.name || 'upload.xlsx').replace(/[\\/:*?"<>|,;()]/g, '_');
    if (safeFileName !== (originalFileName || fileToUpload.name)) {
      message.info(
        `Your file name has been changed to '${safeFileName}' because it contained special characters.`
      );
    }
    formData.append("file", fileToUpload, safeFileName);
    formData.append("type", key);

    const refreshToken = localStorage.getItem("ft_desk_refresh_token");
    if (refreshToken) formData.append("refreshToken", refreshToken);

    this.setState({ isUploading: true });
    axios.post(`${REACT_APP_ENTITY_SERVICE_URL}/v1/template/upload`, formData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ft_desk_token"),
        source: "lego"
      }
    })
      .then((response) => {
        const updatedUploadState = uploadState.clone();
        updatedUploadState.clearFile(activeTab);
        this.setState({
          uploadState: updatedUploadState,
        });
        message.info('File uploaded successfully');
        this.getUploadedData(1);
      })
      .catch((error) => {
        const updatedUploadState = uploadState.clone();
        updatedUploadState.clearFile(activeTab);
        this.setState({
          uploadState: updatedUploadState,
        });
        message.info("Failed to upload file.");
      })
      .finally(() => {
        this.setState({ isUploading: false });
      });
  };

  handleDownloadClick = (record) => {
    const apiUrl = `${REACT_APP_BULK_ENGINE_SERVICE_URL}/download/${record.key}`;
    const token = localStorage.getItem("ft_desk_token");

    axios
      .get(apiUrl, {
        headers: { token },
        responseType: 'json'
      })
      .then((response) => {
        const { s3_url, filename } = response.data;

        let entity = '';
        if (record.upload_type === 'create') entity = 'vehicle';
        else if (record.upload_type === 'edit') entity = 'vehicle';
        else entity = 'file';

        const customFileName = `${entity}_${record.upload_type}_${record.name || filename}`;

        axios.get(s3_url, { responseType: 'blob' })
          .then(blobResponse => {
            const blob = new Blob([blobResponse.data]);
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = customFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch(err => {
            console.error('Blob download failed:', err);
            message.error('Failed to download the file.');
          });
      })
      .catch((error) => {
        console.error('Error downloading metadata:', error);
        message.error('Failed to download file metadata.');
      });
  }

  makeColumns = (arr) => {
    return arr.map((item) => {
      if (item.key === 'actions') {
        return {
          ...item,
          render: (text, record) => {
            const iconClassName = record.enable_download
              ? 'bulk-upload-action-icon'
              : 'bulk-upload-action-icon bulk-upload-action-icon--disabled';
            return (
              <Button
                className="bulk-upload-action-button"
                disabled={!record.enable_download}
                onClick={() => this.handleDownloadClick(record)}
              >
                <img
                  src={downloadIcon}
                  alt="download"
                  className={iconClassName}
                />
              </Button>
            );
          }
        }
      }
      if (item.key === 'name') {
        return {
          ...item,
          render: (text) => (
            <div className="bulk-upload-file-name">{text}</div>
          )
        };
      }
      return item;
    });
  }

  renderBulkUploadSection = () => {
    const { uploadState, activeTab } = this.state;
    const {
      match: { params = {} },
    } = this.props;
    const currentUploadFile = uploadState.getFile(activeTab);
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const componentType = pathParts[pathParts.length - 1].toLowerCase();
    const componentParam = params.component ? params.component.toLowerCase() : '';
    const componentDisplayName =
      (params.component && headingMap[params.component]) ||
      (componentParam && headingMap[componentParam]) ||
      (componentType && headingMap[componentType]) ||
      formatComponentName(componentType);

    const uploadMessages = {
      create: `Upload your file in Excel format below to add ${componentDisplayName} in bulk`,
      update: `Upload your file in Excel format below to update onboarded ${componentDisplayName} in bulk`,
      replace: `Upload your file in Excel format below to replace onboarded ${componentDisplayName} in bulk`,
      delete: `Upload your file in Excel format below to delete onboarded ${componentDisplayName} in bulk`,
    };

    const uploadProps = {
      name: 'file',
      multiple: false,
      accept: '.xlsx,.xls,.csv',
      showUploadList: false,
      beforeUpload: this.handleFileUpload,
      onRemove: this.handleRemoveFile,
      fileList: currentUploadFile ? [currentUploadFile] : []
    };

    return (
      <div className="bulk-upload-section">
        <p className="upload-message">{uploadMessages[activeTab]}</p>

        <div className="csv-practices-box">
          <div className="practices-content">
            <img
              src={excelIcon}
              alt="excel"
              className="excel-icon"
            />
            <div className="practices-text">
              <h4>Excel Best Practices</h4>
              <p>Please ensure your file is structured according to the Freight Tiger {componentDisplayName} template</p>
            </div>
          </div>
          <Button
            type="primary"
            ghost
            onClick={this.handleTemplateDownload}
          >
            Download Template
          </Button>
        </div>
        <div className="upload-section">
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <Icon type="cloud-upload" />
            </p>
            <p className="ant-upload-text">Click or Drag and drop file here to upload</p>
            <p className="ant-upload-hint">
              Allowed file type: Excel | Max Size: 10 MB
            </p>
          </Dragger>
        </div>

        {currentUploadFile && (
          <div className="file-info-section">
            <div className="file-info">
              <Icon type="paper-clip" />
              <span>{currentUploadFile.name}</span>
            </div>
            <div className="action-buttons">
              <Button onClick={this.handleRemoveFile}>
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => this.saveBulkUpload()}
                loading={this.state.isUploading}
              >
                Upload
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderUploadedFilesTable = (columns) => {
    const { uploadedData, pagination } = this.state;
    const currentPagination = pagination || {};
    const tableComponents = {
      header: {
        cell: (props) => {
          const { className, children, ...restProps } = props;
          const combinedClassName = className
            ? `bulk-upload-table-header-cell ${className}`
            : 'bulk-upload-table-header-cell';
          return (
            <th
              {...restProps}
              className={combinedClassName}
            >
              {children}
            </th>
          );
        },
      },
    };

    return (
      <div>
        <h3 className="bulk-upload-uploaded-files-title">Uploaded Files</h3>
        <Table
          columns={columns}
          dataSource={uploadedData}
          rowKey={record => record.fteid}
          pagination={{
            current: currentPagination.current || 1,
            total: currentPagination.total || 0,
            pageSize: currentPagination.pageSize || 10,
          }}
          onChange={paginationChange => {
            this.getUploadedData(paginationChange.current);
          }}
          components={tableComponents}
        />
      </div>
    );
  };

  handleTemplateDownload = () => {
    const { activeTab } = this.state;
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const component = pathParts[pathParts.length - 1].toLowerCase();
    const customFileName = `${component}_${activeTab}_template.xlsx`;

    const link = document.createElement('a');
    if(activeTab === 'create') link.href = createSampleFile;
    else if(activeTab === 'update') link.href = updateSampleFile;
    else if(activeTab === 'replace') link.href = replaceSampleFile; 
    else if(activeTab === 'delete') link.href = deleteSampleFile;
    link.download = customFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };


  render() {
    let {
      match: { params },
    } = this.props
    const columns = this.makeColumns(BULK_UPLOAD_COLUMNS);
    const { isUploading, isLoading } = this.state
    const tabDefinitions = [
      {
        key: 'create',
        label: 'Bulk Create',
        info: 'Add new notification configurations.',
      },
      {
        key: 'update',
        label: 'Bulk Update',
        info: 'Append provided data to existing configurations without overwriting them.',
      },
      {
        key: 'replace',
        label: 'Bulk Replace',
        info: 'Overwrite existing configuration data with the provided data.',
      },
      {
        key: 'delete',
        label: 'Bulk Delete',
        info: 'Disable notification configurations in bulk.',
      },
    ];

    return (
      <div className="bulk-upload-page">
        {(isUploading || isLoading) && (
          <div className="bulk-upload-loader-overlay">
            <Spin tip={isUploading ? "Uploading..." : "Loading..."} size="large" />
          </div>
        )}
        <div className="bulk-upload-page-header">
          <div className="bulk-upload-page-title">
            <Button
              className="bulk-upload-back-button"
              onClick={() => window.history.back()}
            >
              <Icon type="arrow-left" />
            </Button>
            <span>Upload ({headingMap[params.component]})</span>
          </div>
        </div>
        <div className="bulk-upload-container">
          <div className="bulk-upload-box">
            <Row>
              <Tabs defaultActiveKey="create" onChange={this.handleTabChange} activeKey={this.state.activeTab}>
                {tabDefinitions.map((tab) => (
                  <TabPane
                    key={tab.key}
                    tab={(
                      <span className="bulk-upload-tab-label">
                        <span>{tab.label}</span>
                        <Tooltip title={tab.info}>
                          <Icon type="info-circle" className="bulk-upload-tab-info-icon" />
                        </Tooltip>
                      </span>
                    )}
                  >
                    {this.renderBulkUploadSection()}
                    {this.renderUploadedFilesTable(columns)}
                  </TabPane>
                ))}
              </Tabs>
            </Row>
          </div>
        </div>
      </div>
    )
  }
}

export default BulkUpload
